import type { ThemeNames } from '@/themes'
import { ComponentEntry, IllustrationEntry } from './types'
import { defaultIllustrations, themeOverrides } from './constants'

export function resolveEntry(entry: IllustrationEntry): ComponentEntry {
  if (typeof entry === 'function') return { component: entry }
  return { component: entry?.component, fillColor: entry?.fillColor }
}

export function getIllustration(type: string, themeId: ThemeNames | undefined): ComponentEntry {
  const overrides = themeId ? themeOverrides[themeId] : undefined
  const entry = overrides?.[type] ?? defaultIllustrations[type]

  if (!entry) return { component: undefined }

  return resolveEntry(entry)
}

export const getPermissionCheckerErrorIcon = (
  system: string,
  browser: string,
  isMobileOS: boolean
) => {
  if (system === 'android') {
    // android case
    switch (browser) {
      case 'chrome':
        return 'android-settings-error'
      case 'firefox':
        return 'android-padlock-error'
      case 'opera':
        return 'android-shield-error'
      case 'edge':
        return 'android-padlock-error'
      case 'samsung':
        return 'android-padlock-error'
      default:
        return 'media-permissions-checker-error'
    }
  } else if (!isMobileOS) {
    // desktop case
    switch (browser) {
      case 'chrome':
        return 'desktop-settings-error'
      case 'firefox':
        return 'desktop-padlock-error'
      case 'opera':
        return 'desktop-padlock-error'
      case 'edge':
        return 'desktop-padlock-error'
      default:
        return 'media-permissions-checker-error'
    }
  } else {
    // ios case
    return 'media-permissions-checker-error'
  }
}
